import InfoBar from '../redesign/components/InfoBar'
import classes from './nivelacijaKvota.module.css'
import classesK from '../kalkulatori.module.css'
import { useState, useEffect } from 'react'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'

const NivelacijaKvota = () => {
  const [data, setData] = useState({
    values: {
      secondGames: ['', '', '', ''],
      thirdGames: ['', '', '', '', '', ''],
      fourthGames: ['', '', '', '', '', '', '', ''],
      fifthGames: ['', '', '', '', '', '', '', '', '', ''],
    },

    results: {
      secondGames: {
        names: ['-', '-'],
        chances: ['', ''],
        realOdds: ['', ''],
        realOddsPercentage: ['', ''],
        profit: [0],
      },
      thirdGames: {
        names: ['', '', ''],
        chances: ['', '', ''],
        realOdds: ['', '', ''],
        realOddsPercentage: ['', '', ''],
        profit: [0],
      },
      fourthGames: {
        names: ['', '', '', ''],
        chances: ['', '', '', ''],
        realOdds: ['', '', '', ''],
        realOddsPercentage: ['', '', '', ''],
        profit: [0],
      },
      fifthGames: {
        names: ['', '', '', '', ''],
        chances: ['', '', '', '', ''],
        realOdds: ['', '', '', '', ''],
        realOddsPercentage: ['', '', '', '', ''],
        profit: [0],
      },
    },
  })

  const E118 = data.values.secondGames[2]
  const G118 = data.values.secondGames[3]
  const H118 = (1 / Number(E118)) * 100
  const I118 = (1 / Number(G118)) * 100
  const K118 = Number(H118) + Number(I118)
  const M118 = Number(K118) - 100
  const N118 = Number(M118) / 2
  const O118 = Number(H118) - Number(N118)
  const Q118 = Number(I118) - Number(N118)
  const S118 = Number(O118) - Number(Q118)
  const U118 = (Number(O118) * Number(M118)) / 100
  const V118 = (Number(Q118) * Number(M118)) / 100
  const W118 = Number(U118) + Number(V118)
  const Y118 = Number(H118) - Number(V118)
  const AA118 = Number(I118) - Number(U118)
  const AC118 = Number(Y118) + Number(AA118)
  const AE118 = () => {
    if (AC118 >= 100) {
      const result = Number(Number(AC118) - 100).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(100 - Number(AC118)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AH118 = () => {
    if (AC118 > 100) {
      const result = Number(Number(Y118) - Number(AE118())).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(AE118()) + Number(Y118)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AI118 = () => {
    if (AC118 > 100) {
      const result = Number(Number(AA118) - Number(AE118())).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(AE118()) + Number(AA118)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AJ118 = Number((1 / Number(AH118())) * 100)
  const AK118 = Number((1 / Number(AI118())) * 100)

  const AJ118Formatted = isNaN(AJ118) ? '-' : AJ118.toFixed(2)
  const AK118Formatted = isNaN(AK118) ? '-' : AK118.toFixed(2)

  const B115 = data.values.thirdGames[3]
  const D115 = data.values.thirdGames[4]
  const E115 = data.values.thirdGames[5]
  const G115 = (1 / Number(B115)) * 100
  const H115 = (1 / Number(D115)) * 100
  const I115 = (1 / Number(E115)) * 100

  const K115 = Number(G115 + H115 + I115)

  const M115 = Number(K115 - 100)
  const N115 = Number(M115) / 3
  const O115 = Number(G115) - Number(N115)
  const Q115 = Number(H115) - Number(N115)
  const S115 = Number(I115) - Number(N115)
  const U115 = (Number(S115) * Number(M115)) / 100
  const V115 = (Number(Q115) * Number(M115)) / 100
  const W115 = (Number(O115) * Number(M115)) / 100
  const Y115 = (Number(U115) + Number(V115) + Number(W115)) / 100
  const AA115 = Number(G115) - Number(U115)
  const AC115 = Number(H115) - Number(V115)
  const AE115 = Number(I115) - Number(V115)
  const AF115 = Number(AA115) + Number(AC115) + Number(AE115)
  const AG115 = () => {
    if (AF115 >= 100) {
      const result = Number((Number(AF115) - 100) / 3).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number((100 - Number(AF115)) / 3).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AH115 = () => {
    const result =
      AF115 >= 100
        ? Number(AA115 - parseFloat(AG115()))
        : Number(AA115 + parseFloat(parseFloat(AG115())))
    return isNaN(result) ? '-' : result.toFixed(2)
  }

  const AI115 = () => {
    const result =
      AF115 >= 100
        ? Number(AC115 - parseFloat(AG115()))
        : Number(AC115 + parseFloat(AG115()))
    return isNaN(result) ? '-' : result.toFixed(2)
  }

  const AJ115 = () => {
    const result =
      AF115 >= 100
        ? parseFloat(AE115 - parseFloat(AG115()))
        : parseFloat(AE115 + parseFloat(AG115()))
    return isNaN(result) ? '-' : result.toFixed(2)
  }

  const AH115Result = AH115()
  const AI115Result = AI115()
  const AJ115Result = AJ115()

  const AK115 =
    isNaN(AH115Result) || isNaN(AI115Result) || isNaN(AJ115Result)
      ? '-'
      : Number(AH115Result) + Number(AI115Result) + parseFloat(AJ115Result)

  const AL115 = isNaN(AH115Result)
    ? '-'
    : Number((1 / Number(AH115Result)) * 100).toFixed(2)
  const AM115 = isNaN(AI115Result)
    ? '-'
    : Number((1 / Number(AI115Result)) * 100).toFixed(2)
  const AN115 = isNaN(parseFloat(AJ115Result))
    ? '-'
    : parseFloat((1 / parseFloat(AJ115Result)) * 100).toFixed(2)

  const E121 = data.values.fourthGames[4]
  const G121 = data.values.fourthGames[5]
  const H121 = data.values.fourthGames[6]
  const I121 = data.values.fourthGames[7]

  const K121 = (1 / Number(E121)) * 100
  const M121 = (1 / Number(G121)) * 100
  const N121 = (1 / Number(H121)) * 100
  const O121 = (1 / Number(I121)) * 100

  const Q121 = Number(K121 + M121 + N121 + O121)

  const S121 = Number(Q121) - 100

  const U121 = () => {
    if (Q121 >= 100) {
      const result = Number(Q121) - 100
      return isNaN(result) ? '-' : result
    } else {
      const result = 100 - Number(Q121)
      return isNaN(result) ? '-' : result
    }
  }

  const V121 = isNaN(U121()) ? '-' : Number(U121() / 4)

  const W121 = () => {
    if (Q121 >= 100) {
      const result = Number(Number(K121) - Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(K121) + Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  } // procenat nivelacije 6

  const Y121 = () => {
    if (Q121 >= 100) {
      const result = Number(Number(M121) - Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(M121) + Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  } // procenat nivelacije 7

  const AA121 = () => {
    if (Q121 >= 100) {
      const result = Number(Number(N121) - Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(N121) + Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  } // procenat nivelacije 8

  const AC121 = () => {
    if (Q121 >= 100) {
      const result = Number(Number(O121) - Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(O121) + Number(V121)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  } //procenat nivelacije 9

  const AE121 =
    isNaN(W121()) || isNaN(Y121()) || isNaN(AA121()) || isNaN(AC121())
      ? '-'
      : Number(W121()) + Number(Y121()) + Number(AA121()) + Number(AC121())

  const W122 = isNaN(W121())
    ? '-'
    : Number((1 / Number(W121())) * 100).toFixed(2)
  const Y122 = isNaN(Y121())
    ? '-'
    : Number((1 / Number(Y121())) * 100).toFixed(2)
  const AA122 = isNaN(AA121())
    ? '-'
    : Number((1 / Number(AA121())) * 100).toFixed(2)
  const AC122 = isNaN(AC121())
    ? '-'
    : Number((1 / Number(AC121())) * 100).toFixed(2)

  const U126 = data.values.fifthGames[5]
  const V126 = data.values.fifthGames[6]
  const W126 = data.values.fifthGames[7]
  const Y126 = data.values.fifthGames[8]
  const AA126 = data.values.fifthGames[9]
  const U128 = (1 / Number(U126)) * 100
  const V128 = (1 / Number(V126)) * 100
  const W128 = (1 / Number(W126)) * 100
  const Y128 = (1 / Number(Y126)) * 100
  const AA128 = (1 / Number(AA126)) * 100
  const AC128 = Number(U128 + V128 + W128 + Y128 + AA128)

  const AC130 = () => {
    if (AC128 >= 100) {
      const result = Number(AC128 - 100)
      return isNaN(result) ? '-' : result
    } else {
      const result = 100 - Number(AC128)
      return isNaN(result) ? '-' : result
    }
  }

  const AE130 = isNaN(AC130()) ? '-' : Number(AC130()) / 5

  const U132 = () => {
    if (AC128 >= 100) {
      const result = Number(Number(U128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(U128) + Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const V132 = () => {
    if (AC128 >= 100) {
      const result = Number(Number(V128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(V128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const W132 = () => {
    if (AC128 >= 100) {
      const result = Number(Number(W128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(W128) + Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const Y132 = () => {
    if (AC128 >= 100) {
      const result = Number(Number(Y128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(Y128) + Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AA132 = () => {
    if (AC128 >= 100) {
      const result = Number(Number(AA128) - Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    } else {
      const result = Number(Number(AA128) + Number(AE130)).toFixed(2)
      return isNaN(result) ? '-' : result
    }
  }

  const AC132 =
    isNaN(U132()) ||
    isNaN(V132()) ||
    isNaN(W132()) ||
    isNaN(Y132()) ||
    isNaN(AA132())
      ? '-'
      : Number(U132()) +
        Number(V132()) +
        Number(W132()) +
        Number(Y132()) +
        Number(AA132())

  const U134 = isNaN(U132())
    ? '-'
    : Number((1 / Number(U132())) * 100).toFixed(2)
  const V134 = isNaN(V132())
    ? '-'
    : Number((1 / Number(V132())) * 100).toFixed(2)
  const W134 = isNaN(W132())
    ? '-'
    : Number((1 / Number(W132())) * 100).toFixed(2)
  const Y134 = isNaN(Y132())
    ? '-'
    : Number((1 / Number(Y132())) * 100).toFixed(2)
  const AA134 = isNaN(AA132())
    ? '-'
    : Number((1 / Number(AA132())) * 100).toFixed(2)

  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const clearFields = () => {
    setData({
      values: {
        secondGames: ['', '', '', ''],
        thirdGames: ['', '', '', '', '', ''],
        fourthGames: ['', '', '', '', '', '', '', ''],
        fifthGames: ['', '', '', '', '', '', '', '', '', ''],
      },

      results: {
        secondGames: {
          names: ['', ''],
          chances: ['', ''],
          realOdds: ['', ''],
          realOddsPercentage: ['', ''],
          profit: [0],
        },
        thirdGames: {
          names: ['', '', ''],
          chances: ['', '', ''],
          realOdds: ['', '', ''],
          realOddsPercentage: ['', '', ''],
          profit: [0],
        },
        fourthGames: {
          names: ['', '', '', ''],
          chances: ['', '', '', ''],
          realOdds: ['', '', '', ''],
          realOddsPercentage: ['', '', '', ''],
          profit: [0],
        },
        fifthGames: {
          names: ['', '', '', '', ''],
          chances: ['', '', '', '', ''],
          realOdds: ['', '', '', '', ''],
          realOddsPercentage: ['', '', '', '', ''],
          profit: [0],
        },
      },
    })
    setShowInputArea(true)
    setToggleSecondResults(false)
    setToggleThirdResults(false)
    setToggleFourthResults(false)
    setToggleFifthResults(false)
  }
  console.log('realOdds', AJ118Formatted, AK118Formatted)
  const calculateWinningChances = () => {
    const updatedResults = {}

    Object.keys(data.values).forEach((key) => {
      const oddsStartIndex =
        key === 'secondGames'
          ? 2
          : key === 'thirdGames'
          ? 3
          : key === 'fourthGames'
          ? 4
          : 5

      const parsedOdds = (data.values[key].slice(oddsStartIndex) || [])
        .map((odd) => parseFloat(odd))
        .map((odd) => (isNaN(odd) || odd <= 0 ? 0 : odd))
      console.log(parsedOdds)

      const chances = parsedOdds.map((odd) =>
        odd > 0 ? ((1 / odd) * 100).toFixed(2) + '%' : '0%'
      )

      updatedResults[key] = {
        chances,
      }
    })

    setData((prevData) => {
      const updatedResultsWithDetails = { ...updatedResults }

      updatedResultsWithDetails.secondGames = {
        ...prevData.results.secondGames,
        names: [prevData.values.secondGames[0], prevData.values.secondGames[1]],
        chances: [
          updatedResults.secondGames.chances[0],
          updatedResults.secondGames.chances[1],
        ],
        realOdds: [AJ118Formatted || '-', AK118Formatted || '-'],
        realOddsPercentage: [AH118() || '-', AI118() || '-'],
        profit: [
          (
            parseFloat(updatedResults.secondGames.chances[0]) +
            parseFloat(updatedResults.secondGames.chances[1]) -
            100
          ).toFixed(2),
        ],
      }

      updatedResultsWithDetails.thirdGames = {
        ...prevData.results.thirdGames,
        names: [
          prevData.values.thirdGames[0],
          prevData.values.thirdGames[1],
          prevData.values.thirdGames[2],
        ],
        chances: [
          updatedResults.thirdGames.chances[0],
          updatedResults.thirdGames.chances[1],
          updatedResults.thirdGames.chances[2],
        ],
        realOdds: [AL115 || '-', AM115 || '-', AN115 || '-'],
        realOddsPercentage: [AH115() || '-', AI115() || '-', AJ115() || '-'],
        profit: [
          (
            parseFloat(updatedResults.thirdGames.chances[0]) +
            parseFloat(updatedResults.thirdGames.chances[1]) +
            parseFloat(updatedResults.thirdGames.chances[2]) -
            100
          ).toFixed(2),
        ],
      }

      updatedResultsWithDetails.fourthGames = {
        ...prevData.results.fourthGames,
        names: [
          prevData.values.fourthGames[0],
          prevData.values.fourthGames[1],
          prevData.values.fourthGames[2],
          prevData.values.fourthGames[3],
        ],
        chances: [
          updatedResults.fourthGames.chances[0],
          updatedResults.fourthGames.chances[1],
          updatedResults.fourthGames.chances[2],
          updatedResults.fourthGames.chances[3],
        ],
        realOdds: [W122 || '-', Y122 || '-', AA122 || '-', AC122 || '-'],
        realOddsPercentage: [
          W121() || '-',
          Y121() || '-',
          AA121() || '-',
          AC121() || '-',
        ],
        profit: [
          (
            parseFloat(updatedResults.fourthGames.chances[0]) +
            parseFloat(updatedResults.fourthGames.chances[1]) +
            parseFloat(updatedResults.fourthGames.chances[2]) +
            parseFloat(updatedResults.fourthGames.chances[3]) -
            100
          ).toFixed(2),
        ],
      }

      updatedResultsWithDetails.fifthGames = {
        ...prevData.results.fifthGames,
        names: [
          prevData.values.fifthGames[0],
          prevData.values.fifthGames[1],
          prevData.values.fifthGames[2],
          prevData.values.fifthGames[3],
          prevData.values.fifthGames[4],
        ],
        chances: [
          updatedResults.fifthGames.chances[0],
          updatedResults.fifthGames.chances[1],
          updatedResults.fifthGames.chances[2],
          updatedResults.fifthGames.chances[3],
          updatedResults.fifthGames.chances[4],
        ],
        realOdds: [
          U134 || '-',
          V134 || '-',
          W134 || '-',
          Y134 || '-',
          AA134 || '-',
        ],
        realOddsPercentage: [
          U132() || '-',
          V132() || '-',
          W132() || '-',
          Y132() || '-',
          AA132() || '-',
        ],
        profit: [
          (
            parseFloat(updatedResults.fifthGames.chances[0]) +
            parseFloat(updatedResults.fifthGames.chances[1]) +
            parseFloat(updatedResults.fifthGames.chances[2]) +
            parseFloat(updatedResults.fifthGames.chances[3]) +
            parseFloat(updatedResults.fifthGames.chances[4]) -
            100
          ).toFixed(2),
        ],
      }

      return {
        ...prevData,
        results: updatedResultsWithDetails,
      }
    })
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }
  const updateDisabledState = () => {
    const updatedDisabledState = {
      secondGames: data.values.secondGames.every((field) => field !== ''),
      thirdGames: data.values.thirdGames.every((field) => field !== ''),
      fourthGames: data.values.fourthGames.every((field) => field !== ''),
      fifthGames: data.values.fifthGames.every((field) => field !== ''),
    }
    setDisabled((prevDisabled) => ({
      ...prevDisabled,
      ...updatedDisabledState,
    }))
  }

  useEffect(() => {
    updateDisabledState()
  }, [data.values])
  console.log('disabled', disabled)

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  const [toggleSecondResults, setToggleSecondResults] = useState(false)
  const [toggleThirdResults, setToggleThirdResults] = useState(false)
  const [toggleFourthResults, setToggleFourthResults] = useState(false)
  const [toggleFifthResults, setToggleFifthResults] = useState(false)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Nivelacija kvota`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            {/* SECOND GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 2. igre{' '}
                {disabled.secondGames && (
                  <button
                    className={classes.button}
                    onClick={setToggleSecondResults}
                  >
                    Prikaži rezultate
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'secondGames'}
                data={data.values}
                setData={setData}
                labelPrefix={['IGRA 1', 'IGRA 2', 'KVOTA 1', 'KVOTA 2']}
                step={['', '', '0.1', '0.1']}
                min={['', '', '0.1', '0.1']}
                type={['text', 'text', 'number', 'number']}
                rows={2}
                setError={setError}
                calculation={calculateWinningChances}
              />
              {toggleSecondResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 2. igre'
                    results={data.results.secondGames.profit}
                    names={['Marža kladionice ( ukupna na 2. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.secondGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.secondGames.names.length
                          ? [data.results.secondGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={2}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.secondGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.secondGames.names.length
                          ? [data.results.secondGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={2}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisani procenti'
                    results={data.results.secondGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.secondGames.names.length
                          ? [
                              data.results.secondGames.names[i],
                              `${percentage}%`,
                            ]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={2}
                  />
                </>
              )}
            </div>

            {/* THIRD GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 3. igre{' '}
                {disabled.thirdGames && (
                  <button
                    className={classes.button}
                    onClick={setToggleThirdResults}
                  >
                    Prikaži rezultate
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'thirdGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                ]}
                step={['', '', '', '0.1', '0.1', '0.1']}
                min={['', '', '', '0.1', '0.1', '0.1']}
                type={['text', 'text', 'text', 'number', 'number', 'number']}
                rows={3}
                setError={setError}
                calculation={calculateWinningChances}
              />
              {toggleThirdResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 3. igre'
                    results={data.results.thirdGames.profit}
                    names={['Marža kladionice ( ukupna na 3. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.thirdGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={3}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.thirdGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={3}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.thirdGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], `${percentage}%`]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={3}
                  />
                </>
              )}
            </div>

            {/* FOURTH GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 4. igre{' '}
                {disabled.fourthGames && (
                  <button
                    className={classes.button}
                    onClick={setToggleFourthResults}
                  >
                    Prikaži rezultate
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'fourthGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'IGRA 4',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                  'KVOTA 4',
                ]}
                step={['', '', '', '', '0.1', '0.1', '0.1', '0.1']}
                min={['', '', '', '', '0.1', '0.1', '0.1', '0.1']}
                type={[
                  'text',
                  'text',
                  'text',
                  'text',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                rows={4}
                setError={setError}
                calculation={calculateWinningChances}
              />
              {toggleFourthResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 4. igre'
                    results={data.results.fourthGames.profit}
                    names={['Marža kladionice ( ukupna na 4. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.fourthGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.fourthGames.names.length
                          ? [data.results.fourthGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={4}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.fourthGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.fourthGames.names.length
                          ? [data.results.fourthGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={4}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.fourthGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.fourthGames.names.length
                          ? [
                              data.results.fourthGames.names[i],
                              `${percentage}%`,
                            ]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={4}
                  />
                </>
              )}
            </div>

            {/* FIFTH GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 5. igre{' '}
                {disabled.fifthGames && (
                  <button
                    className={classes.button}
                    onClick={setToggleFifthResults}
                  >
                    Prikaži rezultate
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'fifthGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'IGRA 4',
                  'IGRA 5',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                  'KVOTA 4',
                  'KVOTA 5',
                ]}
                step={['', '', '', '', '', '0.1', '0.1', '0.1', '0.1', '0.1']}
                min={['', '', '', '', '', '0.1', '0.1', '0.1', '0.1', '0.1']}
                type={[
                  'text',
                  'text',
                  'text',
                  'text',
                  'text',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                rows={5}
                setError={setError}
                calculation={calculateWinningChances}
              />
              {toggleFifthResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 5. igre'
                    results={data.results.fifthGames.profit}
                    names={['Marža kladionice ( ukupna na 5. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.fifthGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={5}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.fifthGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={5}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.fifthGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], `${percentage}%`]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={5}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NivelacijaKvota
